module.exports = require("mobx-react-lite");